import { render, staticRenderFns } from "./productlisting.vue?vue&type=template&id=64dbfa44&"
import script from "./productlisting.vue?vue&type=script&lang=js&"
export * from "./productlisting.vue?vue&type=script&lang=js&"
import style0 from "./productlisting.vue?vue&type=style&index=0&id=64dbfa44&prod&lang=css&"
import style1 from "./productlisting.vue?vue&type=style&index=1&id=64dbfa44&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports